import React, { Fragment, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Form } from "semantic-ui-react";

const FleetFilter = ({ filter, setFilter, all, site }) => {
  const fleet = useSelector((state) => state.fleet.fleet);
  const [options, setOptions] = useState({});

  useEffect(() => {
    let filtered = all
      ? fleet.filter((f) => f.model_id === 2)
      : fleet.filter((f) => !f.decommissioned && f.model_id === 2);
    const options = {};
    for (const f of FILTER_OPTIONS) {
      for (const { key } of f.options) {
        const o = [];
        for (const { [key]: value } of filtered) {
          if (!o.some((a) => a.value === value)) {
            o.push({ text: value, value });
          }
        }
        o.sort((a, b) =>
          typeof a.value === "string"
            ? a.value.localeCompare(b.value)
            : a.value - b.value,
        );
        options[key] = o;
        if (filter[key] && filter[key].length > 0) {
          filtered = filtered.filter((f) => filter[key].includes(f[key]));
        }
      }
    }
    setOptions(options);
  }, [fleet, filter, all]);

  const handleChange = (_, { type, value }) => {
    setFilter((prevState) => {
      const newState = {};
      for (const f of FILTER_OPTIONS) {
        for (const { key } of f.options) {
          if (key === type) {
            if (value.length > 0) {
              newState[type] = value;
            }
            return newState;
          }
          if (prevState[key]) {
            newState[key] = prevState[key];
          }
        }
      }
    });
  };

  return (
    <Form>
      {(site ? FILTER_OPTIONS.slice(0, -1) : FILTER_OPTIONS).map((f) => (
        <Fragment key={f.category}>
          <Form.Field label={`By ${f.category}:`} />
          <Form.Group width="16">
            {f.options.map((o) => (
              <Form.Dropdown
                fluid
                search
                selection
                clearable
                multiple
                key={o.key}
                width={o.width}
                type={o.key}
                selectOnBlur={false}
                placeholder={o.placeholder}
                options={options[o.key] || []}
                value={filter[o.key] || []}
                onChange={handleChange}
              />
            ))}
          </Form.Group>
        </Fragment>
      ))}
    </Form>
  );
};

const FILTER_OPTIONS = [
  {
    category: "Location",
    options: [
      { placeholder: "Country", key: "country", width: 3 },
      { placeholder: "State / Province", key: "state_province", width: 5 },
      { placeholder: "City", key: "city", width: 8 },
    ],
  },
  {
    category: "Customer",
    options: [
      { placeholder: "Customer", key: "customer_name", width: 8 },
      { placeholder: "Site Name", key: "site_name", width: 8 },
    ],
  },
  {
    category: "PPID",
    options: [{ placeholder: "PPID", key: "powerplant_id", width: 16 }],
  },
];

export default FleetFilter;
